// Generated types for IntrinsicExpansionTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { LLMTaskReadAPI, LLMTaskWriteAPI } from '../../llm_task/types/llmtask';
import { LLMTaskReadAPISchemaObject, LLMTaskWriteAPISchemaObject } from '../../llm_task/types/llmtask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface IntrinsicExpansionTaskReadAPI extends LLMTaskReadAPI {
}

export interface IntrinsicExpansionTaskWriteAPI extends LLMTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const IntrinsicExpansionTaskReadAPISchemaObject = LLMTaskReadAPISchemaObject.extend({}).passthrough();
export const IntrinsicExpansionTaskReadAPISchema: z.ZodType<IntrinsicExpansionTaskReadAPI> = IntrinsicExpansionTaskReadAPISchemaObject;

export const IntrinsicExpansionTaskWriteAPISchemaObject = LLMTaskWriteAPISchemaObject.extend({}).passthrough();
export const IntrinsicExpansionTaskWriteAPISchema: z.ZodType<IntrinsicExpansionTaskWriteAPI> = IntrinsicExpansionTaskWriteAPISchemaObject;
